/**
 * The LLM generates HTML elements like <br> and <br/>, but these arrive
 * escaped. In order to render a few specific elements, we need to unescape
 * them.
 *
 * We also need to handle escaped blockquote syntax (&gt; at the beginning of lines).
 */
export function reinstateHtmlElements(markdown: string): string {
  return markdown.replace(/&lt;br[/]?&gt;/gi, '<br>').replace(/^&gt; /gm, '> ');
}
